import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import Layout from "@/components/Layout";
import ProductCard from "@/components/ProductCard";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const initialQ = params.get("q") || "";
  const [q, setQ] = useState(initialQ);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initialQ) return;
    (async () => {
      setLoading(true);
      const { data } = await api.get("/products", { params: { q: initialQ } });
      setItems(data);
      setLoading(false);
    })();
  }, [initialQ]);

  const submit = (e) => {
    e.preventDefault();
    setParams(q ? { q } : {});
  };

  return (
    <Layout>
      <div className="px-4 pt-6">
        <h1 className="font-heading font-black text-2xl text-brand-blue">Ricerca</h1>
        <form onSubmit={submit} className="relative mt-4">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" strokeWidth={2.5} />
          <Input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cerca prodotti, marche, categorie..."
            className="pl-11 h-12 rounded-full bg-white border-border shadow-sm"
            autoFocus
          />
        </form>
        {initialQ && (
          <p className="text-sm text-slate-500 mt-3">
            Risultati per <span className="font-bold text-slate-900">"{initialQ}"</span>: {items.length}
          </p>
        )}
        {loading ? (
          <div className="mt-8 text-center text-slate-500">Ricerca in corso...</div>
        ) : items.length === 0 && initialQ ? (
          <div className="mt-12 text-center text-slate-500">Nessun risultato trovato.</div>
        ) : (
          <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {items.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
